import { useSync } from '@/services/sync'
import { OfflineIcon } from '@/components/icons'
import './OfflineBanner.css'

/**
 * Persistent offline indicator mounted by AppShell. Reads the sync context;
 * renders nothing while online (contract §1, §3).
 */
export function OfflineBanner() {
  const { online } = useSync()
  if (online) return null
  return (
    <div className="ui-offline-banner" role="status">
      <OfflineIcon size={16} />
      <span>Je bent offline. Alles blijft op dit apparaat bewaard en synchroniseert zodra je weer online bent.</span>
    </div>
  )
}
